<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 178 178"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_124_208)">
      <path
        d="M140.878 37.1992H110.902V67.1754H140.878V37.1992Z"
        fill="#65A9D2"
      />
      <path
        d="M66.8277 110.902H36.8516V140.879H66.8277V110.902Z"
        fill="#65A9D2"
      />
      <path
        d="M103.679 74.0508H73.7031V104.027H103.679V74.0508Z"
        fill="#87CFF3"
      />
      <path
        d="M66.8277 74.0508H36.8516V104.027H66.8277V74.0508Z"
        fill="#65A9D2"
      />
      <path
        d="M140.878 74.0508H110.902V104.027H140.878V74.0508Z"
        fill="#65A9D2"
      />
      <path
        d="M104.027 110.902H74.0508V140.879H104.027V110.902Z"
        fill="#65A9D2"
      />
      <path
        d="M103.679 36.8516H73.7031V66.8277H103.679V36.8516Z"
        fill="#65A9D2"
      />
      <path d="M178 74.0119H148.023V103.988H178V74.0119Z" fill="#3075A4" />
      <path d="M29.9762 74.0119H0V103.988H29.9762V74.0119Z" fill="#3075A4" />
      <path
        d="M66.8502 37.1386H36.874V67.1148H66.8502V37.1386Z"
        fill="#65A9D2"
      />
      <path
        d="M140.861 111.15H110.885V141.127H140.861V111.15Z"
        fill="#65A9D2"
      />
      <path d="M103.989 148.024H74.0127V178H103.989V148.024Z" fill="#3075A4" />
      <path d="M103.989 0H74.0127V29.9762H103.989V0Z" fill="#3075A4" />
    </g>
    <defs>
      <clipPath id="clip0_124_208">
        <rect width="178" height="178" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'IconByTheNumbers',
    props: {
      width: {
        type: [String, Number],
        default: '178',
      },
      height: {
        type: [String, Number],
        default: '178',
      },
    },
  };
</script>
